import * as React from 'react'

/**
 * Given some "Private" styled component taking `PRIVATE_PROPS` and a map
 * function returning `PRIVATE_PROPS` from `PUBLIC_PROPS`, return a styled
 * component that takes `PUBLIC_PROPS`
 *
 * This wrapping in a proxy component is necessary because yak does not have a
 * `.withConfig` to avoid passing some props to the dom component. To avoid
 * having transient props (prefixed with a $) in the "public" interface of a
 * component, we need the proxy component to map the "public" interface to the
 * transient props.
 */
export function withPrivatePublicMap<PRIVATE_PROPS, PUBLIC_PROPS>(
  Private: React.FunctionComponent<PRIVATE_PROPS>,
  map: (prop: React.PropsWithoutRef<PUBLIC_PROPS>) => PRIVATE_PROPS,
): React.ForwardRefExoticComponent<React.PropsWithoutRef<PUBLIC_PROPS> & React.RefAttributes<unknown>> {
  // Since the wrapped `Private` component might accept props, we also need to
  // wrap everything in a `React.forwardRef`.

  // eslint-disable-next-line react/display-name
  return React.forwardRef((props: React.PropsWithoutRef<PUBLIC_PROPS>, ref: React.ForwardedRef<unknown>) => {
    return <Private {...map(props)} ref={ref} />
  })
}
